import { Component } from '@angular/core';

@Component({
    selector: 'footer-menu',
    templateUrl: './footer.component.html'
})


export class FooterComponent {
}
